<template>
  <div class="row">
    <div class="col-12 mb-3">
      <button class="btn btn-primary" @click="$router.push({name: 'edit_avatar' , params: {id: 'new'}})">
        افزودن
        <i class="fas fa-plus" />
      </button>
      <hr>
    </div>
    <div class="col-12 mb-3">
      <h4 class="text-right text--orange">
جستجور آواتار ها
      </h4>
    </div>
    <div class="col-12">
      <form class="text-right" v-on:keyup.enter="search">
        <div class="row">
          <div class="col-12 col-sm-6 col-md-4 col-lg-6 col-xl-3">
            <div class="form-group">
              <label for="name" class="text-right mb-1">نام</label>
              <input id="name" v-model="filters.name" type="text" class="fv-sm form-control" placeholder="عنوان">
            </div>
          </div>
          <div class="col-12 col-sm-6 col-md-4 col-lg-6 col-xl-3">
            <div class="form-group">
              <label for="order" class="text-right mb-1">ترتیب</label>
              <input id="order" v-model.number="filters.order" type="text" class="fv-sm form-control"
                     placeholder="ترتیب">
            </div>
          </div>
          <div class="col-12 text-left">
            <button @click.prevent="search" class="btn btn-info">
              جستجو
              <i class="fas fa-search" />
            </button>
          </div>
        </div>
      </form>
      <hr>
    </div>
    <div class="col-12">
      <fvTable class="fv-size-lg" v-if="avatars.length > 0" :fields="fields" :rows="avatars">

        <template slot="field-#" slot-scope="scope">
          <span>{{scope.index + 1 + ( (page - 1) * (pagination.page === 1 ? 0 : pagination.per_page ) )}}</span>
        </template>

        <template slot="field-نام" slot-scope="scope">
          {{scope.row.name || '---'}}
        </template>

        <template slot="field-ترتیب" slot-scope="scope">
          {{scope.row.order || '---'}}
        </template>

        <template slot="field-عکس" slot-scope="scope">
          <img v-if="scope.row.path" :src="`${mediaUrl}/${scope.row.path}?max=20`" :alt="scope.row.path"/>
          <span v-else >---</span>
        </template>

        <template slot="field-actions" slot-scope="scope">
          <button @click="$router.push({name: 'edit_avatar' , params : {id: scope.row.id} })"
                  class="btn btn-warning btn-sm">
            تغییر
            <i class="far fa-edit" />
          </button>
        </template>

      </fvTable>
    </div>
    <div class="col-12 text-center mt-5" v-if="Object.keys(avatars).length > 0 && pagination.pages > 1">
      <appPagination :pageCount="pagination.pages" v-model="page" @input="search"/>
    </div>

  </div>
</template>
<script>

  import {mapActions} from "vuex"
  import {API_MEDIA_URL} from "../../env"
  import appPagination from "../../components/appPagination";
  export default {
    name: 'avatars',
    data() {
      const {query} = this.$route
      const {page, filters , sort} = query;
      const filtersObj = filters ? JSON.parse(filters) : {}
      return {
        ...mapActions('main', [
          'crud'
        ]),
        avatars: [],
        fields: ['#', 'نام', 'ترتیب', 'عکس', 'actions'],
        query,
        filters: filtersObj,
        sort: sort || '-_score,-created_at',
        page : parseInt(page) || 1,
        pagination: {},
        mediaUrl : API_MEDIA_URL
      }
    },
    components: {
      appPagination
    },
    methods: {
      async getData() {
        this.$store.commit('main/SET', {key: 'loading', value: true})
        try {
          const apiFilters = await this.$generateFilter(this.filters)
          const avatars = await this.crud({
            action: 'get',
            section: 'avatars',
            query: `${this.$queryGenerator(apiFilters, this.sort)}${this.page >= 1 ? `&page=${this.page}` : ''}`
          })

          if (avatars.data && avatars.data.items) {
            const result = avatars.data.items
            this.avatars = result
            this.pagination = avatars.data.pagination
          }
        } catch (e) {
          // console.log(e)
        } finally {
          this.$store.commit('main/SET', {key: 'loading', value: false})
        }
      },
      async search() {
        this.filters = await this.$validateFilter(this.filters)
        await this.$router.push({
          query: {
            filters: Object.keys(this.filters).length > 0 ? JSON.stringify(this.filters) : undefined,
            sort: this.sort || undefined,
            page: this.page
          }
        })
      }
    },

    async mounted() {
      await this.getData()
    },
    watch: {
      '$route.query'() {
        this.getData();
      }
    },

    // beforeUpdate() {
    // }
  };
</script>
<style>
</style>
